import type { NdtCatalogItem } from "../../../domain/ndt/ndt-technical-catalog.js";
import type { NdtCatalogRepository } from "../../../repositories/operational-repositories.js";

const STORAGE_KEY = "ndt_catalog_items";

export class InMemoryNdtCatalogRepository implements NdtCatalogRepository {
  private items = new Map<string, NdtCatalogItem>();

  constructor() {
    this.loadFromStorage();
  }

  private loadFromStorage() {
    try {
      if (typeof localStorage !== "undefined") {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          const parsed: NdtCatalogItem[] = JSON.parse(stored);
          for (const item of parsed) {
            this.items.set(item.id, item);
          }
        }
      }
    } catch (e) {
      console.warn("Failed to load NDT catalog items from storage:", e);
    }
  }

  private persistStorage() {
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(this.items.values())));
      }
    } catch (e) {
      console.warn("Failed to persist NDT catalog items to storage:", e);
    }
  }

  async findById(id: string): Promise<NdtCatalogItem | null> {
    this.loadFromStorage();
    return this.items.get(id) || null;
  }

  async listAll(): Promise<readonly NdtCatalogItem[]> {
    this.loadFromStorage();
    return Array.from(this.items.values());
  }

  async save(item: NdtCatalogItem): Promise<void> {
    this.items.set(item.id, { ...item });
    this.persistStorage();
  }

  async delete(id: string): Promise<void> {
    this.items.delete(id);
    this.persistStorage();
  }
}
